<template>
  <v-cotainer fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Drawer Management
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addDrawer()">
            <v-icon left color="teal">add</v-icon>
            New Drawer
          </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="productDrawerHeader"
          :items="productDrawersByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-btn icon class="mx-0" @click="viewDrawer(props.item)">
                <v-icon color="pink">remove_red_eye</v-icon>
              </v-btn>
            </td>
            <td>
              <b>{{ props.item["name"] }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editProductDrawer(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <!-- <td>
              <v-btn icon class="mx-0" @click="deleteProductDrawer(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td> -->
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Set Dialog -->
    <v-dialog v-model="productDrawerDialog" persistent max-width="1000px">
      <v-card persistent v-if="currentDrawer">
        <v-card-title class="primary white--text">
          <span class="headline">Create Product Drawer</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Product Drawer Name"
                  v-model="currentDrawer.name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-layout
                  wrap
                  v-for="(item, index) in currentDrawer.items"
                  :key="index + '1'"
                >
                  <v-flex xs6 sm6 md6>
                    <v-select
                      dense
                      autocomplete
                      item-text="text"
                      :item-value="'value'"
                      :items="productListByBrand"
                      label="Product"
                      clearable
                      v-model="item.product"
                    ></v-select>
                  </v-flex>
                  <v-flex xs1 sm1 md1>
                    <v-btn
                      icon
                      color="primary"
                      v-if="
                        index == currentDrawer.items.length - 1 && item.product
                      "
                      @click="addProd()"
                    >
                      <v-icon>add_circle</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="primary"
                        @click="removeProd(index)"
                        v-else-if="item.product"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="productDrawerDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            v-if="currentDrawer && currentDrawer['.key']"
            @click="updateProductDrawer()"
            flat
            >Update</v-btn
          >
          <v-btn 
            color="blue darken-1" 
            :disabled="!currentDrawer.name"
            v-else @click="save()" flat
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="productViewDialog" persistent max-width="1000px">
      <v-card persistent v-if="currentDrawer">
        <v-card-title class="primary white--text">
          <span class="headline">Product Drawer</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Product Drawer Name"
                  disabled
                  readonly
                  v-model="currentDrawer.name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-layout
                  wrap
                  v-for="(item, index) in currentDrawer.items"
                  :key="index + '1'"
                >
                  <v-flex xs6 sm6 md6>
                    <v-select
                      dense
                      autocomplete
                      item-text="text"
                      :item-value="'value'"
                      disabled
                      :items="productListByBrand"
                      label="Product"
                      readonly
                      clearable
                      v-model="item.product"
                    ></v-select>
                  </v-flex>
                  <v-flex xs1 sm1 md1>
                    <v-btn
                      icon
                      color="primary"
                      @click="viewTransactions(item.product)"
                    >
                      <v-icon>remove_red_eye</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="productViewDialog = false" flat
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="productTransactionDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Transactions</span>
          <v-spacer></v-spacer>
           <v-btn outlined @click="addEntry()" v-if="!isAddEditMode">
            <v-icon left color="teal">add</v-icon>
            New Entry
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md v-if="!isAddEditMode">
              
        <v-data-table
          :headers="productTransactionHeader"
          :items="transactions"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ new Date(props.item["date"]).toLocaleDateString("en-GB") }}</b>
            </td>
             <td>
              <b>{{ props.item["invoiceId"] }}</b>
            </td>
             <td>
              <b>{{ props.item["quantity"] }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editEntry(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <!-- <td>
              <v-btn icon class="mx-0" @click="deleteProductDrawer(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td> -->
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
          </v-container>
           <v-container grid-list-md v-else-if="currentEntry && isAddEditMode"> 
                  <v-layout wrap>
              <v-flex xs6 sm6 md6>
                <v-text-field
                  label="Quantity"
                  type="number"
                  v-model="currentEntry.quantity"
                ></v-text-field>
              </v-flex>
               <v-flex xs6 sm6 md6>
                   <v-menu
                  :close-on-content-click="false"
                  v-model="datePicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentEntry.date"
                    label="Order Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="currentEntry.date"
                    @input="datePicker = false"
                  ></v-date-picker>
                </v-menu>
               </v-flex>
                  </v-layout>
           </v-container>
        </v-card-text>
        <v-card-actions v-if="!isAddEditMode">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="productTransactionDialog = false" flat
            >Cancel</v-btn
          >
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="isAddEditMode = false" flat
            >Cancel</v-btn
          >
           <v-btn
            color="blue darken-1"
            v-if="currentEntry && currentEntry['.key']"
            @click="udpateTransaction()"
            flat
            >Update</v-btn
          >
          <v-btn color="blue darken-1" v-else @click="saveTrnasaction()" flat
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productDrawerDialog: false,
      currentDrawer: null,
      datePicker: false,
      productViewDialog: false,
      productTransactionDialog: false,
      isAddEditMode: false,
      transactions : [],
      productDrawerHeader: [
        { text: "View", value: "deposit - ID" },
        { text: "Drawer Name", value: "deposit - ID" },
        { text: "Edit", value: "edit" },
      ],
      currentEntry: null,
      productTransactionHeader: [
        { text: "Date", value: "deposit - ID" },
        { text: "Invoice Id", value: "deposit - ID" },
        { text: "Quantity", value: "deposit - ID" },
        { text: "Edit", value: "edit" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "productDrawers",
      this.$root.$firebaseRefs.productDrawer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "drawerTransactions",
      this.$root.$firebaseRefs.drawerTransaction
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      return this.products
        .filter((item) => {
          return item["brand"] === this.selectedBrand;
        })
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    productDrawersByBrand() {
      return this.productDrawers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },

  },
  methods: {
    addDrawer() {
      this.currentDrawer = {
        name: null,
        items: [
          {
            product: null,
          },
        ],
        brand: this.selectedBrand,
      };
      this.productDrawerDialog = true;
    },
    save() {
      this.$root.$firebaseRefs.productDrawer.push(this.currentDrawer);
      this.productDrawerDialog = false;
    },
    saveTrnasaction() {
      this.currentEntry.date = new Date(this.currentEntry.date).getTime();
      this.$root.$firebaseRefs.drawerTransaction.push(this.currentEntry);
      this.isAddEditMode = false;
      this.currentEntry = false;
      this.transactions = this.drawerTransactions.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          item["product"] == this.currentProductId &&
          item.drawer == this.currentDrawer[".key"]
        );
      });
    },
    viewDrawer(set) {
      this.currentDrawer = set;
      this.productViewDialog = true;
    },
    addEntry() {
      this.isAddEditMode = true;
      this.currentEntry = {
        brand: this.selectedBrand,
        quantity: 1,
        date: new Date().toISOString().substr(0, 10),
        product: this.currentProductId,
        drawer: this.currentDrawer[".key"],
      };
    },
    editProductDrawer(set) {
      this.currentDrawer = set;
      this.productDrawerDialog = true;
    },
    editEntry(set) {
      this.currentEntry = set;
      (this.currentEntry.date = new Date(this.currentEntry.date)
        .toISOString()
        .substr(0, 10)),
        (this.isAddEditMode = true);
    },
    viewTransactions(productId) {
      this.currentProductId = productId;
      this.productTransactionDialog = true;
      this.transactions = this.drawerTransactions.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          item["product"] == this.currentProductId &&
          item.drawer == this.currentDrawer[".key"]
        );
      });
    },
    addProd() {
      let itemToAdd = {
        product: null,
      };
      this.currentDrawer.items.push(itemToAdd);
    },
    removeProd(index) {
      this.currentDrawer.items.splice(index, 1);
    },
    updateProductDrawer() {
      let key = this.currentDrawer[".key"];
      delete this.currentDrawer[".key"];
      this.$root.$firebaseRefs.productDrawer
        .child(key)
        .update(this.currentDrawer, () => {
          this.currentDrawer = null;
          this.productDrawerDialog = false;
        });
    },
    udpateTransaction() {
      let key = this.currentEntry[".key"];
      delete this.currentEntry[".key"];
      this.currentEntry.date = new Date(this.currentEntry.date).getTime();
      this.$root.$firebaseRefs.drawerTransaction
        .child(key)
        .update(this.currentEntry, () => {
          this.currentEntry = null;
          this.isAddEditMode = false;
          this.transactions = this.drawerTransactions.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          item["product"] == this.currentProductId &&
          item.drawer == this.currentDrawer[".key"]
        );
      });
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/productDrawer/productDrawer.vue